import {gql} from 'apollo-boost'

export const GET_DASHBOARD_BORROWER_COUNT = gql`
  query dashboardBorrowerCount {
    dashboardBorrowerCount
  }
`

export const GET_DASHBOARD_LOAN_AMOUNT = gql`
  query dashboardLoanAmount {
    dashboardLoanAmount
  }
`

export const GET_DASHBOARD_OUTSTANDING_AMOUNT = gql`
  query dashboardOutstandingAmount {
    dashboardOutstandingAmount
  }
`

export const GET_DASHBOARD_PROSECUTION_COUNT = gql`
  query dashboardProsecutionCount {
    dashboardProsecutionCount
  }
`

export const GET_DASHBOARD_LOAN_SPENDING = gql`
  query dashboardLoanSpending {
    dashboardLoanSpending {
      count
      amount
      borrowers {
        id
        idCardNumber
        date
        fullName
        contractId
        contractNo
        contractName
        amount
      }
    }
  }
`

export const GET_DASHBOARD_PAYMENT_DUE = gql`
  query dashboardPaymentDue {
    dashboardPaymentDue {
      count
      amount
      borrowers {
        id
        idCardNumber
        fullName
        contractId
        contractNo
        contractName
        date
        amount
      }
    }
  }
`

export const GET_DASHBOARD_DEBT_TRACKING = gql`
  query dashboardDebtTracking {
    dashboardDebtTracking {
      count
      stageAgings{
        stage
        count
      }
      followers{
        id
        fullName
        contractId
        contractNo
        contractName
        count
        stageAgings{
          stage
          count
        }
      }
    }
  }
`

export const GET_DASHBOARD_STAGE_AGINGS = gql`
  query dashboardStageAgings {
    dashboardStageAgings {
      stage
      count
      outstandingAmountFeePenalty
    }
  }
`

export const GET_DASHBOARD_BORROWERS = gql`
  query dashboardBorrowers {
    dashboardBorrowers {
      id
      idCardNumber
      fullName
      contractId
      contractNo
      contractName
      agingDate
      agingNumber
      accruedFeeRemain
      accruedPenaltyRemain
      outstandingAmountRemain
      educationStatusName
    }
  }
`

export const GET_DASHBOARD_LOAN_AMOUNT_BORROWERS = gql`
  query dashboardLoanAmountBorrowers {
    dashboardLoanAmountBorrowers {
      id
      idCardNumber
      fullName
      contractId
      contractNo
      contractName
      agingDate
      agingNumber
      contractAmount
      loanAmount
      principleRemain
      educationStatusName
    }
  }
`

export const GET_DASHBOARD_OUTSTANDING_REMAIN_BORROWERS = gql`
  query dashboardOutstandingRemainBorrowers {
    dashboardOutstandingRemainBorrowers {
      id
      idCardNumber
      fullName
      contractId
      contractNo
      contractName
      agingDate
      agingNumber
      accruedFeeRemain
      accruedPenaltyRemain
      outstandingAmountRemain
      educationStatusName
    }
  }
`

export const GET_DASHBOARD_PROSECUTION_BORROWERS = gql`
  query dashboardProsecutionBorrowers {
    dashboardProsecutionBorrowers {
      id
      idCardNumber
      fullName
      contractId
      contractNo
      contractName
      agingDate
      agingNumber
      caseStatus
      caseStatusName
      educationStatusName
    }
  }
`

export const GET_DASHBOARD_LOAN_SPENDING_BORROWERS = gql`
  query dashboardLoanSpendingBorrowers {
    dashboardLoanSpendingBorrowers {
      id
      idCardNumber
      fullName
      contractId
      contractNo
      contractName
      date
      amount
      educationStatusName
    }
  }
`

export const GET_DASHBOARD_PAYMENT_DUE_BORROWERS = gql`
  query dashboardPaymentDueBorrowers {
    dashboardPaymentDueBorrowers {
      id
      idCardNumber
      fullName
      contractId
      contractNo
      contractName
      date
      amount
      educationStatusName
    }
  }
`

export const GET_DASHBOARD_STAGE_AGING_NORMAL_BORROWERS = gql`
  query dashboardStageAgingNormalBorrowers {
    dashboardStageAgingNormalBorrowers {
      id
      idCardNumber
      fullName
      contractId
      contractNo
      contractName
      agingDate
      agingNumber
      accruedFeeRemain
      accruedPenaltyRemain
      outstandingAmountRemain
      educationStatusName
    }
  }
`

export const GET_DASHBOARD_STAGE_AGING_ALL_BORROWERS = gql`
  query dashboardStageAgingAllBorrowers {
    dashboardStageAgingAllBorrowers {
      id
      idCardNumber
      fullName
      contractId
      contractNo
      contractName
      agingDate
      agingNumber
      accruedFeeRemain
      accruedPenaltyRemain
      outstandingAmountRemain
      educationStatusName
    }
  }
`

export const GET_DASHBOARD_STAGE_AGING_1_BORROWERS = gql`
  query dashboardStageAging1Borrowers {
    dashboardStageAging1Borrowers {
      id
      idCardNumber
      fullName
      contractId
      contractNo
      contractName
      agingDate
      agingNumber
      accruedFeeRemain
      accruedPenaltyRemain
      outstandingAmountRemain
      educationStatusName
    }
  }
`

export const GET_DASHBOARD_STAGE_AGING_2_BORROWERS = gql`
  query dashboardStageAging2Borrowers {
    dashboardStageAging2Borrowers {
      id
      idCardNumber
      fullName
      contractId
      contractNo
      contractName
      agingDate
      agingNumber
      accruedFeeRemain
      accruedPenaltyRemain
      outstandingAmountRemain
      educationStatusName
    }
  }
`

export const GET_DASHBOARD_STAGE_AGING_3_BORROWERS = gql`
  query dashboardStageAging3Borrowers {
    dashboardStageAging3Borrowers {
      id
      idCardNumber
      fullName
      contractId
      contractNo
      contractName
      agingDate
      agingNumber
      accruedFeeRemain
      accruedPenaltyRemain
      outstandingAmountRemain
      educationStatusName
    }
  }
`

export const GET_DASHBOARD_FOLLOW_UP_BORROWERS = gql`
  query dashboardFollowUpBorrowers($id: ID!) {
    dashboardFollowUpBorrowers(id: $id) {
      id
      idCardNumber
      fullName
      contractId
      contractNo
      contractName
      agingDate
      agingNumber
      accruedFeeRemain
      accruedPenaltyRemain
      outstandingAmountRemain
      educationStatusName
    }
  }
`

export const GET_DASHBOARD_MONTHLY_PAYMENT_HISTORIES = gql`
  query dashboardMonthlyPaymentHistories($year: Int) {
    dashboardMonthlyPaymentHistories(year: $year) {
      name
      year
      month
      billAmount
      paymentAmount
    }
  }
`
